/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react'

import { Spin } from 'antd'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'

const MapView = ({ task, isLoading }: { task: any; isLoading: boolean }) => {
  const x = task?.address?.location?.x
  const y = task?.address?.location?.y

  const hasValidLocation = x != null && y != null && x !== 0 && y !== 0

  const map = useMemo(() => {
    if (!hasValidLocation) return null

    const position: [number, number] = [x, y]

    return (
      <MapContainer
        key={`${x}-${y}`}
        center={position}
        zoom={13}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position} />
      </MapContainer>
    )
  }, [hasValidLocation, x, y])

  return (
    <div style={{ height: '250px', width: '100%' }}>
      {isLoading ? (
        <div
          style={{
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" tip="Carregando mapa..." />
        </div>
      ) : hasValidLocation ? (
        map
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f5f5f5',
            color: '#999',
          }}
        >
          Localização inválida
        </div>
      )}
    </div>
  )
}

export default MapView
